import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
const titleInit = "Edit Date";
const textInit = "Please edit date";
/**
 * @param {{
 *   show: boolean,
 *   options?: {
 *     title: string,
 *     text: string
 *   }[],
 * onHide:()=>void,
 * submitClick:()=>void,
 * id: BigInteger,
 * currentDate:string
 * }} props
 * */
function ModalEditDate2({ show, onHide, submitClick = () => {}, id = null, currentDate = "", options = {} }) {
  const [val, setVal] = useState("");
  const [title, setTitle] = useState(titleInit);
  const [text, setText] = useState(textInit);
  // Sync state ketika modal dibuka
  const sync = () => {
    setVal(currentDate || "");

    setTitle((prev) => options.title ?? prev);
    setText((prev) => options.text ?? prev);
  };
  const reset = () => {
    setVal("");
    setTitle(titleInit);
    setText(textInit);
  };
  useEffect(() => {
    if (show) {
      sync();
    } else {
      reset();
    }
  }, [show, currentDate]);

  const handleChange = (e) => {
    setVal(e.target.value);
  };

  const handleSubmit = () => {
    if (!val) return;
    submitClick({ id, val });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <ModalHeader closeButton>
        <h5 className="modal-title">{title}</h5>
      </ModalHeader>

      <ModalBody>
        <div className="mb-3">
          <input type="date" value={val} onChange={handleChange} className="form-control" />
        </div>

        <div className="alert bg-inverse bg-opacity-15">{text}</div>
      </ModalBody>

      <ModalFooter>
        <button type="button" disabled={!val} onClick={handleSubmit} className="btn btn-outline-theme">
          Save changes
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalEditDate2;
